<template>
  <WeeklyTask></WeeklyTask>
</template>
<script>
import WeeklyTask from '@/components/WeeklyTask' 
export default {
  components:{
    WeeklyTask,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped></style>
